import {client as http} from '../../http_client';

export default {
    state: {
        dashboardStats: {}
    },
    getters: {
        dashboardStats: state => state.dashboardStats
    },
    mutations: {
        setDashboardStats(state, stats) {
            state.dashboardStats = stats;
        }
    },
    actions: {
        getDashboardStats({commit}) {
            return new Promise((resolve, reject) => {
                http.get('stats/dashboard', {}).then(response => {
                    commit('setDashboardStats', response.data);
                    resolve(response.data);
                }, err => {
                    console.log(err);
                    reject(err.response ? err.response.data : err);
                });
            });
        }
    }
}
